define('customPlugins/atnHeightAdjuster',['knockout', 'lodash', './utils'],
    function(ko, _, utils) {
        'use strict';
        ko.bindingHandlers.atnHeightAdjuster = {
            init: function(element, valueAccessor) {
                ko.computed(function() {
                    var value = valueAccessor();
                    element.style.height =
                        (utils.viewportDimension().height - ko.utils.unwrapObservable(value)) + 'px';
                });
            }
        };
    });
